import React, { Fragment, useContext, useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import ButtonMui from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import { AlertContext } from "../../context/AlertContext";
import Spinner from "./Spinner";
import { AuthContext } from "../../context/AuthContext";
import { ServiciosContext } from "../../context/ServiciosContext";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../../assets/css/DataTableDemo.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Tag } from "primereact/tag";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { useNavigate } from "react-router-dom";
import Menu from "./Menu";
import { jsPDF } from "jspdf";

import {
  calcularBarthel,
  calcularLawtonBrody,
  calcularTinetti,
  calcularNorton,
  calcularMinimental,
  calcularGoldberg,
  calcularYesavage,
  calcularFragilidad,
  calcularReloj,
  diagnosticoNutricional,
  parseEstudio,
} from "./ValoracionGeriatricaIntegral";

function formatDate2(dateString) {
  if (!dateString) return "";
  var allDate = dateString.replace("T", " ");
  allDate = allDate.replace(".", " ");
  allDate = allDate.split(" ");
  var thisDate = allDate[0].split("-");
  var newDate = [thisDate[2], thisDate[1], thisDate[0]].join("/");
  return newDate;
}

const EVALUACIONES_PERIODICAS = [
  { titulo: "Evaluación Médica Periódica", key: "medica" },
  { titulo: "Evaluación Social Periódica", key: "social" },
  { titulo: "Evaluación Kinesiológica Periódica", key: "kinesiologica" },
  { titulo: "Evaluación Psicológica Periódica", key: "psicologica" },
  { titulo: "Evaluación Nutricional Periódica", key: "nutricional" },
  { titulo: "Evaluación Visual Periódica", key: "visual" },
  { titulo: "Evaluación Auditiva Periódica", key: "auditiva" },
];

const siNo = (valor) =>
  valor === true || valor === "true"
    ? "SI"
    : valor === false || valor === "false"
    ? "NO"
    : "-";

const textoDominio = (key, item) => {
  if (key === "medica") {
    return [item.vgi, item.evolucion].filter(Boolean).join("\n") || "-";
  }
  if (key === "visual") {
    const lineas = [
      `Usa anteojos: ${siNo(item.usaAnteojos)}`,
      `Arco senil: ${siNo(item.arcoSenil)}`,
      `Cataratas: ${siNo(item.cataratas)}`,
      `Deterioro visual funcional: ${siNo(item.deterioroVisualFuncional)}`,
    ];
    if (item.evolucion) lineas.push(item.evolucion);
    return lineas.join("\n");
  }
  if (key === "auditiva") {
    const lineas = [
      `Tiene problemas de audición: ${siNo(item.tieneProblemasAudicion)}`,
      `Gravedad: ${item.gravedadAudicion || "-"}`,
      `Usa audífonos: ${siNo(item.usaAudifonos)}`,
    ];
    if (item.evolucion) lineas.push(item.evolucion);
    return lineas.join("\n");
  }
  return item.evolucion || "-";
};

export default function ResumenValoracionGeriatrica(props) {
  let navigate = useNavigate();
  const [globalFilter, setGlobalFilter] = useState(null);
  const [dialogPacientes, setDialogPacientes] = useState(false);

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state, usuarioAutenticado } = authContext;

  const serviciosContext = useContext(ServiciosContext);
  const {
    statusAcceso,
    pacientes,
    selectedRowPaciente,
    setSelectedRowPaciente,
    obtenerPacientes,
    obtenerAcceso,
    valoracionesGeriatricas,
    obtenerValoracionesGeriatricas,
    evaluaciones,
    obtenerEvaluaciones,
    evolucionesSociales,
    obtenerEvolucionesSociales,
    evolucionesKinesiologicas,
    obtenerEvolucionesKinesiologicas,
    evolucionesPsicologicas,
    obtenerEvolucionesPsicologicas,
    evolucionesNutricionalesPeriodicas,
    obtenerEvolucionesNutricionalesPeriodicas,
    evolucionesVisuales,
    obtenerEvolucionesVisuales,
    evolucionesAuditivas,
    obtenerEvolucionesAuditivas,
  } = serviciosContext;

  useEffect(() => {
    usuarioAutenticado();
  }, []);

  useEffect(() => {
    if (state.usuario) {
      obtenerAcceso({
        usuarioId: state.usuario.id,
        layout: "ValoracionGeriatrica",
      });
    }
  }, [state]);

  useEffect(() => {
    obtenerPacientes({
      geriatricoId: Number(localStorage.getItem("geriatricoElegidoId")),
    });
  }, []);

  const accesoDenegado = () => {
    mensajeAlerta(
      "Acceso",
      "No tiene permiso para acceder a esta pantalla !.",
      "error"
    );
    navigate("/");
    return;
  };

  const addClick = (e) => {
    setDialogPacientes(true);
    setSelectedRowPaciente(null);
  };

  const onHidePacientes = (e) => {
    setSelectedRowPaciente(null);
    setDialogPacientes(false);
  };

  const aceptarClickPacientes = (e) => {
    if (selectedRowPaciente) {
      obtenerValoracionesGeriatricas({ pacienteId: selectedRowPaciente.id });
      obtenerEvaluaciones({ pacienteId: selectedRowPaciente.id });
      obtenerEvolucionesSociales({ pacienteId: selectedRowPaciente.id });
      obtenerEvolucionesKinesiologicas({ pacienteId: selectedRowPaciente.id });
      obtenerEvolucionesPsicologicas({ pacienteId: selectedRowPaciente.id });
      obtenerEvolucionesNutricionalesPeriodicas({
        pacienteId: selectedRowPaciente.id,
      });
      obtenerEvolucionesVisuales({ pacienteId: selectedRowPaciente.id });
      obtenerEvolucionesAuditivas({ pacienteId: selectedRowPaciente.id });
      setDialogPacientes(false);
    }
  };

  const idTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">ID</span>
        {rowData.id}
      </Fragment>
    );
  };

  const nombreTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Nombre</span>
        {rowData.nombre}
      </Fragment>
    );
  };

  const documentoTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Documento</span>
        {rowData.numeroDocumento}
      </Fragment>
    );
  };

  const headerPacientes = (
    <Fragment>
      <div className="p-d-flex export-buttons">
        <span
          style={{ marginLeft: "1em", marginRight: "1em" }}
          className="p-input-icon-left"
        >
          <i className="pi pi-search" />
          <InputText
            fullWidth
            type="search"
            onInput={(e) => setGlobalFilter(e.target.value)}
            placeholder="Buscar"
          />
        </span>
        <Tag value="Residentes"></Tag>
      </div>
    </Fragment>
  );

  const renderFooterPacientes = () => {
    return (
      <div>
        <ButtonMui
          onClick={aceptarClickPacientes}
          color="primary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CheckIcon />}
        >
          Aceptar
        </ButtonMui>
        <ButtonMui
          onClick={onHidePacientes}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
      </div>
    );
  };

  const ultimaValoracion =
    valoracionesGeriatricas && valoracionesGeriatricas.length > 0
      ? valoracionesGeriatricas[0]
      : null;

  const ultimaPorDominio = {
    medica: evaluaciones && evaluaciones.length > 0 ? evaluaciones[0] : null,
    social:
      evolucionesSociales && evolucionesSociales.length > 0
        ? evolucionesSociales[0]
        : null,
    kinesiologica:
      evolucionesKinesiologicas && evolucionesKinesiologicas.length > 0
        ? evolucionesKinesiologicas[0]
        : null,
    psicologica:
      evolucionesPsicologicas && evolucionesPsicologicas.length > 0
        ? evolucionesPsicologicas[0]
        : null,
    nutricional:
      evolucionesNutricionalesPeriodicas &&
      evolucionesNutricionalesPeriodicas.length > 0
        ? evolucionesNutricionalesPeriodicas[0]
        : null,
    visual:
      evolucionesVisuales && evolucionesVisuales.length > 0
        ? evolucionesVisuales[0]
        : null,
    auditiva:
      evolucionesAuditivas && evolucionesAuditivas.length > 0
        ? evolucionesAuditivas[0]
        : null,
  };

  const obtenerGruposEscalas = () => {
    const barthel = parseEstudio(ultimaValoracion?.barthel);
    const lawtonBrody = parseEstudio(ultimaValoracion?.lawtonBrody);
    const tinetti = parseEstudio(ultimaValoracion?.tinetti);
    const norton = parseEstudio(ultimaValoracion?.norton);
    const escalaValoracionMental = parseEstudio(
      ultimaValoracion?.escalaValoracionMental
    );
    const goldberg = parseEstudio(ultimaValoracion?.goldberg);
    const yesavage = parseEstudio(ultimaValoracion?.yesavage);
    const evaluacionNutricional = parseEstudio(
      ultimaValoracion?.evaluacionNutricional
    );
    const fragilidad = parseEstudio(ultimaValoracion?.fragilidad);
    const reloj = parseEstudio(ultimaValoracion?.reloj);

    return [
      {
        grupo: "Clínica",
        filas: [["Tinetti", calcularTinetti(tinetti)]],
      },
      {
        grupo: "Funcional",
        filas: [
          ["Barthel", calcularBarthel(barthel)],
          ["Escala de Lawton y Brody", calcularLawtonBrody(lawtonBrody)],
          ["Norton", calcularNorton(norton)],
          ["Fragilidad", calcularFragilidad(fragilidad)],
        ],
      },
      {
        grupo: "Nutricional",
        filas: [
          [
            "Diagnóstico Nutricional",
            diagnosticoNutricional(evaluacionNutricional),
          ],
        ],
      },
      {
        grupo: "Salud Mental",
        filas: [
          ["Minimental", calcularMinimental(escalaValoracionMental)],
          ["Reloj", calcularReloj(reloj)],
          ["Escala de Ansiedad y Depresión (Goldberg)", calcularGoldberg(goldberg)],
          ["Yesavage", calcularYesavage(yesavage)],
        ],
      },
    ];
  };

  const renderEscalas = () => {
    const grupos = obtenerGruposEscalas();

    return (
      <Fragment>
        <Typography variant="body2" style={{ marginBottom: "0.5rem" }}>
          {ultimaValoracion
            ? `Fecha: ${formatDate2(ultimaValoracion.fecha)} | Usuario: ${ultimaValoracion.usuario || "-"}`
            : "Sin valoraciones geriátricas cargadas."}
        </Typography>
        {grupos.map(({ grupo, filas }) => (
          <Fragment key={grupo}>
            <Typography variant="h6" style={{ textDecoration: "underline" }}>
              {grupo}
            </Typography>
            <Grid container spacing={3} style={{ marginTop: "0.25rem", marginBottom: "1rem" }}>
              {filas.map(([label, valor]) => (
                <Grid item xs={12} md={4} key={label}>
                  <TextField
                    value={
                      valor === null || valor === undefined || valor === ""
                        ? ""
                        : valor
                    }
                    label={label}
                    fullWidth
                    variant="standard"
                    InputProps={{ readOnly: true }}
                  />
                </Grid>
              ))}
            </Grid>
          </Fragment>
        ))}
      </Fragment>
    );
  };

  const imprimirClick = (e) => {
    if (!selectedRowPaciente) return;

    const doc = new jsPDF();
    doc.setFontSize(14);
    doc.setFont("Times", "bolditalic");
    doc.text("CUADRO RESUMEN VGI", 70, 15);
    doc.setFont("Times", "normal");
    doc.setFontSize(10);
    doc.text(selectedRowPaciente.nombre || "", 14, 23);

    const grupos = obtenerGruposEscalas();
    const evaluador = ultimaValoracion ? ultimaValoracion.usuario || "-" : "-";
    const fecha = ultimaValoracion ? formatDate2(ultimaValoracion.fecha) : "-";
    const body = grupos
      ? grupos.flatMap(({ grupo, filas }) =>
          filas.map(([pauta, valor]) => [
            grupo,
            pauta,
            valor === null || valor === undefined || valor === "" ? "-" : valor,
            evaluador,
            fecha,
          ])
        )
      : [];

    const filasTabla =
      body.length > 0
        ? body
        : [["-", "Sin valoraciones geriátricas cargadas.", "-", "-", "-"]];
    const colX = [10, 40, 110, 140, 175, 200];
    const headers = ["Valoración", "Pauta", "Resultado", "Evaluador", "Fecha"];
    const rowH = 8;
    let y = 28;

    doc.setFontSize(9);
    doc.setFont("Times", "bold");
    headers.forEach((h, i) => {
      doc.rect(colX[i], y, colX[i + 1] - colX[i], rowH);
      doc.text(h, colX[i] + 1, y + 5.5);
    });
    y += rowH;
    doc.setFont("Times", "normal");

    filasTabla.forEach((fila) => {
      if (y + rowH > 280) {
        doc.addPage();
        y = 20;
      }
      fila.forEach((valor, i) => {
        doc.rect(colX[i], y, colX[i + 1] - colX[i], rowH);
        const texto = valor === null || valor === undefined ? "-" : String(valor);
        const lineas = doc.splitTextToSize(texto, colX[i + 1] - colX[i] - 2);
        doc.text(lineas[0] || "", colX[i] + 1, y + 5.5);
      });
      y += rowH;
    });
    y += 10;
    doc.setFontSize(12);
    doc.setFont("Times", "bolditalic");
    doc.text("Últimas Evaluaciones Periódicas", 14, y);
    doc.setFont("Times", "normal");
    y += 8;

    EVALUACIONES_PERIODICAS.forEach(({ titulo, key }) => {
      const item = ultimaPorDominio[key];

      if (y > 265) {
        doc.addPage();
        y = 20;
      }

      doc.setFontSize(10);
      doc.setFont("Times", "bold");
      doc.text(titulo, 14, y);
      y += 5;
      doc.setFont("Times", "normal");

      if (item) {
        doc.text(
          `Fecha: ${formatDate2(item.fecha)}   Usuario: ${item.usuario || "-"}`,
          14,
          y,
        );
        y += 5;
        const texto = textoDominio(key, item);
        const lineas = doc.splitTextToSize(texto, 180);
        doc.text(lineas, 14, y);
        y += lineas.length * 5 + 6;
      } else {
        doc.text("Sin evaluaciones cargadas.", 14, y);
        y += 10;
      }
    });

    window.open(doc.output("bloburl"));
  };

  const renderEvaluacionesPeriodicas = () => (
    <Grid container spacing={2}>
      {EVALUACIONES_PERIODICAS.map(({ titulo, key }) => {
        const item = ultimaPorDominio[key];
        return (
          <Grid item xs={12} md={6} key={key}>
            <Typography
              variant="subtitle1"
              style={{ fontWeight: "bold", marginBottom: "0.25rem" }}
            >
              {titulo}
            </Typography>
            {item ? (
              <Fragment>
                <Typography variant="body2" style={{ marginBottom: "0.25rem" }}>
                  Fecha: {formatDate2(item.fecha)} | Usuario:{" "}
                  {item.usuario || "-"}
                </Typography>
                <Typography variant="body1" style={{ whiteSpace: "pre-wrap" }}>
                  {textoDominio(key, item)}
                </Typography>
              </Fragment>
            ) : (
              <Typography variant="body2">Sin evaluaciones cargadas.</Typography>
            )}
          </Grid>
        );
      })}
    </Grid>
  );

  return (
    <Fragment>
      <Menu />
      {statusAcceso === 0 ? <Spinner /> : null}
      {statusAcceso === 400 ? accesoDenegado() : null}
      {statusAcceso === 200 ? (
        <Fragment>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            style={{ align: "center", margin: "1em", marginTop: "3vw" }}
          >
            <Button
              icon="pi pi-search"
              tooltip="Pacientes"
              className="p-button-rounded p-button-help"
              style={{ marginLeft: "0em" }}
              onClick={addClick}
            />
            <Button
              icon="pi pi-print"
              tooltip="Imprimir"
              className="p-button-rounded p-button-secondary"
              style={{ marginLeft: "1em" }}
              onClick={imprimirClick}
              disabled={!selectedRowPaciente}
            />
          </Grid>

          <Grid item xs={12} style={{ margin: "1em" }}>
            <Typography variant="h5">Resumen</Typography>
            <Typography variant="body1">
              Seleccione un residente para ver el resumen de sus escalas y
              sus últimas evaluaciones periódicas.
            </Typography>
          </Grid>

          {selectedRowPaciente ? (
            <Grid container spacing={3} style={{ padding: "0 1em" }}>
              <Grid item xs={12}>
                <Typography variant="h6">
                  {selectedRowPaciente.nombre}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  variant="h6"
                  style={{ textDecoration: "underline" }}
                >
                  Escalas de Valoración
                </Typography>
                {renderEscalas()}
              </Grid>
              <Grid item xs={12}>
                <Typography
                  variant="h6"
                  style={{ textDecoration: "underline" }}
                >
                  Últimas Evaluaciones Periódicas
                </Typography>
                {renderEvaluacionesPeriodicas()}
              </Grid>
            </Grid>
          ) : null}

          <Dialog
            showHeader={false}
            visible={dialogPacientes}
            closable={false}
            footer={renderFooterPacientes()}
            breakpoints={{ "960px": "75vw" }}
            style={{ width: "75vw", paddingBottom: "0" }}
            position="top"
          >
            <Grid container spacing={3} style={{ marginTop: "0vw" }}>
              <Grid item xs={12} md={12}>
                <div className="datatable-responsive-demo">
                  <div className="card">
                    <DataTable
                      value={pacientes}
                      selection={selectedRowPaciente}
                      onSelectionChange={(e) => setSelectedRowPaciente(e.value)}
                      selectionMode="single"
                      dataKey="id"
                      header={headerPacientes}
                      className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-demo"
                      style={{ fontSize: "small", marginTop: "1vw" }}
                      globalFilter={globalFilter}
                      emptyMessage="No hay datos."
                      paginator
                      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                      rows={100}
                      rowsPerPageOptions={[10, 20, 50, 100, 500]}
                      responsiveLayout="scroll"
                    >
                      <Column
                        field="id"
                        header="ID"
                        body={idTemplate}
                        sortable
                      ></Column>
                      <Column
                        field="nombre"
                        header="Apellido y Nombre"
                        body={nombreTemplate}
                        style={{ width: "30%" }}
                        sortable
                      ></Column>
                      <Column
                        field="numeroDocumento"
                        header="Documento"
                        body={documentoTemplate}
                        sortable
                      ></Column>
                    </DataTable>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Dialog>
        </Fragment>
      ) : null}
    </Fragment>
  );
}
